/*
 * Tous ce qui concerne la gestion des wishlist (fiche produit et page wishlist)
 * product_right.php, wishlist_index.php
 */

var button_add_to_wishlist_initial_click_event;

/**
 * Dans la fiche produit. Le bouton ajouter à la wishlist. (product_right.php)
 */
function addToWishlist() {

    var btn = $(this);
    var idElt = btn.data('idelt');
    var form = btn.parents('form#prod_info_' + idElt);

    if (btn.parent().parent().attr('id') == "lightboxAchatExpressV1Brand") {
        var productId = this.getAttribute("data-produitid");
        var sizeId = $("#lightboxAchatExpressV1 input[name='itm_size_" + productId + "']:checked").val();
        var colorId = $("#lightboxAchatExpressV1 input[name='itm_color_" + productId + "']:checked").val();
        var currentPage = 0;
    } else if (typeof form !== "undefined" && form.length) {
        var productId = form.find('[name="produit_id"]').val();
        var colorId = form.find('[name="couleurProd"]').val();
        var sizeId = form.find('[name="tailleProd"]').val();
        if (sizeId == '') {
            sizeId = form.find('[name="itm_size"]:checked').val();
        }
        var currentPage = 0;
    } else {
        var productId = btn.data('productid');
        var colorId = $('#couleurProd_' + idElt).length == 1 ? $('#couleurProd_' + idElt).val() : $('#couleurProd').val();
        var sizeId = $('#tailleProd_' + idElt).length == 1 ? $('#tailleProd_' + idElt).val() : $('#tailleProd').val();
        var currentPage = $('#page').val();
    }

    var wishlist = [];

    let datas = {
        product_id: productId,
        color_id: colorId,
        size_id: sizeId,
        need_color_id: 'true',
        need_size_id: 'true'
    };

    if (!btn.hasClass('existToWishlistButton')) {
        $.ajax({
            url: path_relative_root + "ajax_add_to_wishlist.php",
            type: 'post',
            data: datas
        })
            .done(function (resp) {
                var $alertboxLogin = $("#abox");
                var $alertboxBtns = $("#abox .wrap_btn_abox");
                $alertboxLogin.addClass('box_wishlist');

                if (resp.error) {
                    var message = resp.result.error_message ? resp.result.error_message : resp.message;
                    if (resp.message === "login_required") {
                        var wishlistSubmit = $('.form_submit_wishlist', $alertboxLogin);
                        if (wishlistSubmit.length === 0) {
                            $alertboxBtns
                                .append($(
                                    '<div class="form_submit form_submit_wishlist">' +
                                    '<button class="button primary"  href="javascript:void(0)" onclick="wishlistRedirectLogin(\'' + productId + '\', \'' + currentPage + '\');">' +
                                    '<span>' +
                                    resp.result.btn_connexion +
                                    '</span>' +
                                    '</button>' +
                                    '</div>')
                                );
                        } else {
                            wishlistSubmit.css('display', 'flex');
                        }
                        alert('<div class="box_txt_wishlist">' + resp.result.error_message + '</div>');
                    } else if (resp.message != "error") {
                        $(".disabledBtnTooltip").addClass('blink');
                        setTimeout(function() {
                            $(".disabledBtnTooltip").removeClass('blink');
                        }, 2000);

                        // if the button is inside the div #lightboxAchatExpressV1, display the error message in the lightbox below .size_select_wrapper
                        if (btn.parent().parent().attr('id') == "lightboxAchatExpressV1Brand") {
                            var errorDiv = btn.parent().parent().parent().find('.size_select_wrapper');
                            console.log("errorDiv", errorDiv);
                            errorDiv.append('<div class="error">' + Translator.translate('choose_size') + '</div>');
                            setTimeout(function() {
                                errorDiv.find('.error').remove();
                            }, 3500);
                        }
                    } else {
                        alert(Translator.translate(message));
                    }
                } else {
                    btn.addClass("existToWishlistButton");
                    btn.data('wishlistproductid', resp.result.wishlist_product_id);
                    btn.attr('data-wishlistproductid', resp.result.wishlist_product_id);
                    if (typeof (wishlist) == 'undefined') {
                        wishlist = new Array();
                    }
                    wishlist.push(resp.result.wishlist_row_array);
                    addToWishlistUpdateHeaderCount(resp.result.wishlist_size);

                    /*Recharge la page pour le slider wishlist*/
                    if ($('body.cart.step_1').length) {
                        window.location.reload();
                    }

                    let dl_v3_obj = resp.result.dlv3_wishlist_item;
                    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && Object.keys(dl_v3_obj).length > 0) {
                        DataLayerTrigger.addToWishList(dl_v3_obj['items'], dl_v3_obj['actionField'])
                    }
                }
            });
    } else {
        datas.remove = true;

        $.ajax({
            url: path_relative_root + "ajax_remove_from_wishlist.php",
            type: 'post',
            data: datas
        })
            .done(function (resp) {
                if (!resp.error) {
                    btn.removeClass("existToWishlistButton");
                    btn.data('wishlistproductid', '');
                    btn.attr('data-wishlistproductid', '');
                    addToWishlistUpdateHeaderCount(resp.result.wishlistLength);

                    /*Recharge la page pour le slider wishlist*/
                    if ($('body.cart.step_1').length) {
                        window.location.reload();
                    }
                }
            });
    }
}

/**
 * Permet d'ajour un produit à la wishlist via le rayon (ou la recherche)
 * Utilisation : app/_components/product/achat_express.php/achat_express_search.php
 */
function addToWishlistRay() {

    // On utilise le même que dans la fiche produit car cela fait la même chose
    // mais on donne un nom différent au cas où
    addToWishlist.call(this);
}

$(window).on("removeBasketItemCustom", function () {
    getWishlistProducts();
});

function getWishlistProducts(force = false) {
    if (!$("body").hasClass("cart step_1") && !force) {
        return true;
    }

    let array_elements = document.querySelectorAll('a[data-productid]');

    let array_ids = [];
    if (typeof array_elements != 'undefined' && array_elements.length > 0) {
        for (el of array_elements) {
            let id = el.getAttribute('data-productid');

            if (id !== '' && id !== 'undefined') {
                array_ids.push(id);
            }
        }
        let data = JSON.parse((JSON.stringify(Object.assign({}, array_ids))));

        $.ajax({
            type: 'get',
            url: path_relative_root + 'get_user_all_wishlist.php',
            data: data,
            success: function (response) {
                if (typeof response == 'undefined' || !response || response.length == 0) {
                    return;
                }

                let array_product_id = JSON.parse(response);
                let i = 0;
                let wishlistProductIds = [];
                userWishlist = [];

                for (i = 0; i < array_product_id.length; i++) {
                    let wp = array_product_id[i];
                    userWishlist.push(wp.fk_produit_id + "_" + wp.fk_taille_id + "_" + wp.fk_couleur_id);
                    wishlistProductIds.push(wp.fk_produit_id);
                }

                for (product_wishlist in array_product_id) {
                    let selector = 'a[data-productid="' + array_product_id[product_wishlist].fk_produit_id + '"]';
                    selector += '[data-sizeid="' + array_product_id[product_wishlist].fk_taille_id + '"]';
                    $(selector).addClass("existToWishlistButton");
                    $(selector).attr('data-wishlistproductid', array_product_id[product_wishlist].wishlist_product_id);
                }

                let lookbookProductCountInput = $("#products_look input[name='nb_products']");
                if (lookbookProductCountInput.length > 0) {
                    let productCount = lookbookProductCountInput.val();
                    let productLookId = $("#products_look input[name='produit_look_id']").val();
                    let isProductLookInWishlist = true;

                    let j = 0;
                    for (j = 0; j < productCount; j++) {
                        var productId = $("#products_look input[name='products_" + j + "_product']").val();
                        if (!wishlistProductIds.includes(productId)) {
                            isProductLookInWishlist = false;
                        }
                    }

                    let lookbookBtn = $("#addToWishlistButton_" + productLookId);
                    if (isProductLookInWishlist) {
                        lookbookBtn.addClass("existToWishlistButton");
                        lookbookBtn.attr('onclick','removeLookFromWishlist.call(this)');
                    } else {
                        lookbookBtn.removeClass("existToWishlistButton");
                        lookbookBtn.attr('onclick','addLookToWishlist.call(this)');
                    }
                }
            }
        });
    }
}

/**
 *
 * @param productId
 * @param itm_rr_id
 * @returns {boolean}
 */
function checkProductInWishlist(productId, itm_rr_id) {
    let productElem = itm_rr_id ? productId + itm_rr_id : productId;
    let btnWishlist = productId && !itm_rr_id ? 'addToWishlistButton_' + productId : itm_rr_id ? 'addToWishlistButton_' + productId + itm_rr_id : 'addToWishlistButton';

    let colorId = $("#couleurProd_" + productElem).length ? $("#couleurProd_" + productElem).val() : $("#couleurProd").val();
    let sizeId = $("#tailleProd_" + productElem).length ? $("#tailleProd_" + productElem).val() : $("#tailleProd").val();

    if (colorId === undefined || colorId === '') {
        colorId = 0;
    }

    if (sizeId === undefined || sizeId === '') {
        sizeId = $("#prod_info_" + productElem).find('[name="itm_size"]:checked').val();
        if (sizeId === undefined || sizeId === '') {
            sizeId = 0;
        }
    }

    if (typeof productId != "undefined" && typeof colorId != "undefined" && typeof sizeId != "undefined") {
        $.ajax({
            type: 'get',
            url: path_relative_root + 'get_user_wishlist.php',
            data: {'product_id': productId, 'size_id': sizeId, 'color_id': colorId},
            success: function (response) {
                var userWishlist = JSON.parse(response);
                if (userWishlist.length) {
                    changeBtnAddWishlist(true, btnWishlist);
                    return true;
                } else {
                    changeBtnAddWishlist(false, btnWishlist);
                    return false;
                }
            }
        });
    } else {
        changeBtnAddWishlist(false, btnWishlist);
        return false;
    }
}

/*
 * Permet de changer l'action et le visuel du bouton d'ajout à la wishlist
 */
function changeBtnAddWishlist(in_wishlist, btn = false) {

    let btnWishlist = (btn !== false ? btn : 'addToWishlistButton');

    if (in_wishlist) {
        $("#" + btnWishlist).attr("href", "javascript:;");
        $("span", "#" + btnWishlist).html(Translator.translate("exist_to_wishlist_button_label"));
        $("#" + btnWishlist).removeClass("addToWishlistButton").addClass("existToWishlistButton");
    } else {
        $("#" + btnWishlist).attr("href", "javascript:;");
        $("span", "#" + btnWishlist).html(Translator.translate("wishlist"));
        $("#" + btnWishlist).removeClass("existToWishlistButton").addClass("addToWishlistButton");
    }
}

function wishlistRedirectLogin(div_id, currentPage) {
    $.get(path_relative_root + "ajax_add_to_wishlist.php?login_required=1&div_id=" + div_id + "&currentPage=" + currentPage, function () {
        document.location.href = path_relative_root + create_link('connexion_login') + "?from=front&div_id=" + div_id;
    });
}

function addToWishlistUpdateHeaderCount(nr) {

    if (!document.body.classList.contains('mobile')) {
        if (nr === 0) {
            $("#topLogin .wishlist_cnt").addClass('empty');

        } else {

            $("#topLogin .wishlist_cnt").html('(' + nr + ')').removeClass('empty');
        }

        var response_html = ajax_file(path_relative_root + 'ajax_show_wishlist.php');
        $("#wishlist_top").html(response_html);
    }
}

function showSendWishlistModal() {

    if ($('#sendwishlistbox').length == 0) {
        $.ajax({
            url: path_relative_root + "ajax_send_wishlist.php",
            success: function (response) {
                if ($('#sendwishlistbox').length == 0) {
                    $('body').append(response);
                    if ($('#g-recaptcha').length > 0) {

                        grecaptcha.render('g-recaptcha');
                    }
                }
            },
            complete: function () {
                openMultiShad('sendwishlistbox');
                window.scrollTo({top: 0, behavior: 'smooth'}); // scroll to top
            }
        });
    } else {
        openMultiShad('sendwishlistbox');
        window.scrollTo({top: 0, behavior: 'smooth'}); // scroll to top
    }
}

function closeSendWishlistLightBox() {
    var backBtn = $("#content_sendwishlistbox > .w-form-line.w-submit button");
    if (backBtn.length) { 
        backBtn.click()
    } else {
        closeMultiShad('sendwishlistbox')
    }
}

function addAllWpToCart()
{
    var i = 0;
    var wishlistProductId = "";
    var wp = $(".addToCartFromWishlist");
    for (i = 0; i < wp.length; i++) {
        wishlistProductId += "," + wp[i].getAttribute('data-id');
    }
    addWpToCart(wishlistProductId);
}

function addWpToCart(wishlistProductId) {
    if (typeof wishlistProductId != "string") {
        wishlistProductId = wishlistProductId.toString();
    }

    var selectedProducts = wishlistProductId.split(',');

    $.post(path_relative_root + "ajax_add_panier_wishlist.php", {data: wishlistProductId}, function(resp) {
        var data_layer_products = window.data_layer_products;
        var dtl_products = [];
        if (resp == "ok") {
            if (Object.keys(data_layer_products).length > 0) {
                for (const property in data_layer_products) {
                    if (selectedProducts.indexOf(property) !== -1) {
                        dtl_products.push(data_layer_products[property])
                    }
                }
            }

            if (dtl_products.length > 0) {
                var dataLayer = window.dataLayer || []
                pushToWshopBus({
                    "event": "addToCart",
                    "ecommerce": {
                        'currencyCode' : 'window.siteCurrency',
                        "add": {
                            "products": dtl_products
                        }
                    }
                })

            }
            if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && typeof dlv3_action_fields !== 'undefined') {
                var impressions = JSON.parse(dl_v3_impressions);
                var actionField = JSON.parse(dlv3_action_fields);
                var selectedItem = [];
                for (var impression in impressions) {
                    if (impressions[impression]['wishlist_product_id'] == wishlistProductId) {
                        selectedItem.push(impressions[impression]);
                        actionField['revenue'] = impressions[impression]['price'];
                        actionField['event_id'] = '';
                        actionField['cart_id'] = '';
                        DataLayerTrigger.addToCart(selectedItem, actionField);
                    }
                }
            }

            document.location.href = path_relative_root + create_link('order_basket');
        } else {
            $('.lightbox .form_submit .button span').html(Translator.translate("close"));
        }
    });
}

/**
 * Envoie le formulaire de la lightbox wishlist avec gestion des erreurs
 * Utilisation : wishlist_index.php
 */
function sendWishListForm(form) {

    var friendMail = form.elements['friend_email'].value;
    var inputMailElm = $(form.elements['friend_email']);

    if (friendMail.length > 0) {

        inputMailElm.removeClass('inputErr');
        var data = {
            'to_mails': friendMail,
            'to_message': 'Wishlist',
            'your_name': form.elements['customer_firstname'].value,
            'your_mail': form.elements['customer_email'].value
        };

        var error = false;
        var reportMessage = '';
        $.ajax({
            url: path_relative_root + create_link('ajax_send_wishlist_form'),
            data: data
        }).done(function (response) {

            $('.zone_text').css({border: ''});

            if (response.split(',')[0] === 'ok') {
                if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
                    pushToWshopBus({
                        "event": "sendWish_click",
                    });
                }
                var sing = (response.split(',').length > 2) ? 'sendfriend_ok_plur' : 'sendfriend_ok_sing';
                reportMessage = Translator.translate(sing);
            }
            if (response === '1' || response === '2') {
                error = true;
                reportMessage = Translator.translate('sendfriend_error_mail_friends_invalid');
            } else if (response === '3') {
                error = true;
                reportMessage = Translator.translate('sendfriend_error_no_message');
            } else if (response === '4') {
                error = true;
                reportMessage = Translator.translate('sendfriend_error_no_name');
            } else if (response === '5' || response === '6') {
                error = true;
                if (response === '5') {
                    reportMessage = Translator.translate('sendfriend_error_no_my_mail');
                } else {
                    reportMessage = Translator.translate('sendfriend_error_my_mail_invalid');
                }
            } else if (response === 'token_error') {
                error = true;
                reportMessage = Translator.translate('error_token_security');
            } else if (response.split(',')[0] === '7') {
                error = true;
                reportMessage = Translator.translate(sing);
            }

            var emailReportElm = $('.email_wishlist_report');
            emailReportElm.html(reportMessage);
            if (error) {
                inputMailElm.parent('label').addClass('w-has-error');
                inputMailElm.addClass('inputErr');
                emailReportElm.addClass('error');
            } else {
                emailReportElm.removeClass('error');
                inputMailElm.val('');
            }
            emailReportElm.removeClass('cache');
        });

    } else {
        inputMailElm.parent('label').addClass('w-has-error');
        inputMailElm.addClass('inputErr');
    }

    return false;
}

// Pour mettre les produits selectionnés dans le panier
function wishToBasketUpdate(draggedElement, fromDrag) {

    var url = path_relative_root + create_link('order_basket');

    var typeRedirect = (new URL(location.href)).searchParams.get('type_redirect');

    if (typeRedirect == 'out_of_stock') {
        url += '?type_redirect=out_of_stock';
    }

    var removeBtn;

    if (!fromDrag) {
        removeBtn = draggedElement;
    } else {
        removeBtn = draggedElement.querySelector(".remove_wish");
    }

    $(removeBtn).addClass('processing');

    var selectedProducts = $(removeBtn).attr("data-id");
    var id_configurator = $(removeBtn).attr("id-configurator");
    var prodId = $(removeBtn).attr("data-produit-id");
    var colorId = $(removeBtn).attr("data-color-id");
    var sizeId = $(removeBtn).attr("data-size-id");

    let datas = {
        data: selectedProducts,
        idConfigurator: id_configurator
    };

    if (prodId !== undefined) {
        datas.productId = prodId;
    }

    if (colorId !== undefined) {
        datas.colorId = colorId;
    }

    if (sizeId !== undefined) {
        datas.sizeId = sizeId;
    }

    $.post(path_relative_root + create_link('ajax_add_panier_wishlist'), datas, function(resp) {
        if (resp == "ok") {
            if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && prodId !== undefined && typeof dl_v3_wishlist_impressions !== 'undefined' && dl_v3_wishlist_impressions !== undefined) {
                DataLayerTrigger.wishlist_cart_product_action(dl_v3_wishlist_impressions, dlv3_action_wishlist_fields, prodId, "add_to_cart");
            }

            $.ajax({
                url: url,
                type : 'post',
                data : {
                    returnHtml : "ajax"
                },
                cache : false,
                success : function (res) {

                    try {
                        res = JSON.parse(res);
                    } catch (e) {
                        console.error('JSON ERROR: could not parse data');
                        return false;
                    }

                    res = $('<div />').html(res.datas);
                    document.querySelector('.cart_main_table.basket.dropper').innerHTML = $('.cart_main_table.basket.dropper', res).html();
                    document.querySelector('.cart_main_table.wishlist.dropper').innerHTML = $('.cart_main_table.wishlist.dropper', res).html();
                    document.querySelector('#tunnel_right_col').innerHTML = $('#tunnel_right_col', res).html();
                    if (typeof wShop !== 'undefined' && wShop.$refs.wCouponForm) {
                        wShop.$refs.wCouponForm.reloadBloc+=1;
                    }
                    // If the variable is not defined or the constant is equal to false
                    if (typeof copyWishlist === 'undefined' || copyWishlist == false) {
                        removeFromWish(removeBtn, fromDrag);
                    }

                    try {
                        dragDropWishlist();
                    } catch(e) {
                        console.warn('dragDropWishlist: could not reinit drag and drop');
                        console.warn(e);
                    }

                    // Update basket/wishlist products
                    var response = ajax_file("ajax_show_basket.php");
                    var nbProducts = $(".cart_main_table.basket .cart_product_line").length;
                    var nbWishlist = $(".cart_main_table.wishlist .cart_product_line").length;
                    if ($('#cart_btn').length) { // Tunnel mobile

                        $('#cart_btn').attr('data-cart', nbProducts);
                        $('.toggleCartTypeBtn.basket .nb_products').html(response);
                        $('.toggleCartTypeBtn.wishlist .nb_products').html(nbWishlist);
                    } else {

                        document.getElementById('cart_top').innerHTML = response;
                    }

                    /***** Reassurance swiper tunel right re init *****/
                    initTunnelReaSwiper();

                    //Allow to keep the heart filled for products in the wishlist when another product is moved to basket
                    getWishlistProducts();

                    // Need to check if addToWishlistUpdateHeader is a valid function
                    if (typeof addToWishlistUpdateHeader == 'function') {
                        try {
                            // Try updating the header content with the wishlist size
                            addToWishlistUpdateHeader(formatWishlistHeaderContent(resp), false);
                        } catch {
                            // Failed to retrieve a valid data for the update
                            console.warn('addToWishlistUpdateHeader: no data to update');
                        }
                    } else {
                        // Create custom event to update the header with the wishlist size if the function is not defined
                        var wishToBasket_addToWishlistUpdateHeader_evt = new CustomEvent("wishToBasket_addToWishlistUpdateHeader", { detail: { nbWishlist: nbWishlist}});
                        window.dispatchEvent(wishToBasket_addToWishlistUpdateHeader_evt);
                    }

                    // Create custom event on success in order to do extra script on client side
                    var wishToBasket_success_evt = new CustomEvent("wishToBasket_success", { detail: { nbWishlist: nbWishlist } });
                    window.dispatchEvent(wishToBasket_success_evt);

                },
                complete : function() {
                    if (typeof lazyload != "undefined") {
                        lazyload.init();
                    }

                    /* Adding a CustomEvent to target in FO site to pass a function to the effective complete of adding a product from wishlist to basket to avoid moving the updateCartElements in the complete of wishToBasket->side effects */
                    var evt = new CustomEvent("wishToBasket_complete");
                    window.dispatchEvent(evt);

                    /*
                    * hides the confirm delete product basket modal if it exists (Hesperide)
                    */
                    if ($('#confirmDeleteProductBasket').length) {

                        closeMultiShad('confirmDeleteProductBasket');

                        if (typeof remove_shad === 'function') {

                            remove_shad();
                        }
                    }
                }
            });
        }
    });

    /**
     * Updates cart element (cart rollover || cart page)
     * See overrided function on site
     */
    updateCartElements();
}